import { wordsResponse } from '../../types';

export enum userWordsActionTypes {
  FETCH_USER_WORDS = 'FETCH_USER_WORDS',
  FETCH_USER_WORDS_SUCCESS = 'FETCH_USER_WORDS_SUCCESS',
  FETCH_DIFF_WORDS_USER = 'FETCH_DIFF_WORDS_USER',
  FETCH_DIFF_WORDS_USER_SUCCESS = 'FETCH_DIFF_WORDS_USER_SUCCESS',
  DIFFICULT_WORDS_EMPTY = 'DIFFICULT_WORDS_EMPTY',
  DIFFICULT_WORDS_REMOVE = 'DIFFICULT_WORDS_REMOVE',
}
interface fetchUserFordsAction {
  type: userWordsActionTypes.FETCH_USER_WORDS;
}

interface fetchUserWordsActionSuccess {
  type: userWordsActionTypes.FETCH_USER_WORDS_SUCCESS;
  payload: wordsResponse[];
}

interface fetchDiffWordsAction {
  type: userWordsActionTypes.FETCH_DIFF_WORDS_USER;
}
interface diffWordsEmpty {
  type: userWordsActionTypes.DIFFICULT_WORDS_EMPTY;
}
interface diffWordsRemove {
  type: userWordsActionTypes.DIFFICULT_WORDS_REMOVE;
}

interface fetchDiffWordsActionSuccess {
  type: userWordsActionTypes.FETCH_DIFF_WORDS_USER_SUCCESS;
  payload: wordsResponse[];
}
export type UserWordsAction =
  | fetchUserFordsAction
  | fetchUserWordsActionSuccess
  | fetchDiffWordsActionSuccess
  | fetchDiffWordsAction
  | diffWordsEmpty
  | diffWordsRemove;

export enum bookActionTypes {
  FETCH_WORDS = 'FETCH_WORDS',
  FETCH_WORDS_SUCCESS = 'FETCH_WORDS_SUCCESS',
  FETCH_WORDS_ERROR = 'FETCH_WORDS_ERROR',
  SET_GROUP = 'SET_GROUP',
  SET_PAGE = 'SET_PAGE',
  CREATE_USER_WORDS = 'CREATE_USER_WORDS',
  UPDATE_USER_WORDS = 'UPDATE_USER_WORDS',
  FETCH_WORDS_USER_SUCCESS = 'FETCH_WORDS_USER_SUCCESS',
  FETCH_WORDS_USER = 'FETCH_WORDS_USER',
  REMOVE_WORDS = 'REMOVE_WORDS',
}

interface fetchBookAction {
  type: bookActionTypes.FETCH_WORDS;
}

interface fetchBookActionSuccess {
  type: bookActionTypes.FETCH_WORDS_SUCCESS;
  payload: wordsResponse[];
}
interface fetchBookActionUserSuccess {
  type: bookActionTypes.FETCH_WORDS_USER_SUCCESS;
  payload: wordsResponse[];
}
interface fetchBookActionUser {
  type: bookActionTypes.FETCH_WORDS_USER;
}

interface fetchBookActionError {
  type: bookActionTypes.FETCH_WORDS_ERROR;
}
interface SetPage {
  type: bookActionTypes.SET_PAGE;
  payload: number;
}
interface SetGroup {
  type: bookActionTypes.SET_GROUP;
  payload: number;
}

interface CreateUserWords {
  type: bookActionTypes.CREATE_USER_WORDS;
}
interface UpdateUserWords {
  type: bookActionTypes.UPDATE_USER_WORDS;
}
interface removeWords {
  type: bookActionTypes.REMOVE_WORDS;
}

export type BookAction =
  | fetchBookAction
  | fetchBookActionSuccess
  | fetchBookActionError
  | SetGroup
  | SetPage
  | CreateUserWords
  | UpdateUserWords
  | fetchBookActionUserSuccess
  | fetchBookActionUser
  | removeWords;
